// Local
// export const API_URL = 'http://localhost:3001';
// export const API_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
export const API_URL = 'http://172.16.57.126:3001';

// export const API_URL = 'http://192.168.137.164:3001';
// export const FRONTEND_URL  = 'http://localhost:3000';
export const FRONTEND_URL  = 'https://mhcet-reg-dev.hubblehox.ai/api';
export const BILLDESK_URL = 'http://34.93.35.227:8086';
export const KEYCLOCK_REALM = 'CET_DEV_NEW';
export const KEYCLOCK_CLIENT = 'CET_DEV_NEW';
export const KEYCLOCK_USERNAME = 'admin';
export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
export const KEYCLOAK_REDIRECT_URI = 'http://localhost:3000/mhcet/home';



export const AES_KEY = "0a1a57889030315bd571c8f72ba1c3b2ea811e2de93b9e34a4e2e3e88cba2c7a";
export const AES_IV = "76c2b153ff33ba05d5cfaa1ece032868";

// new UAT
// export const API_URL = 'http://localhost:3001';
// export const FRONTEND_URL  = 'http://localhost:3000';
// export const BILLDESK_URL = 'http://34.93.35.227:8086';
// export const KEYCLOCK_REALM = 'CET_DEV_NEW';
// export const KEYCLOCK_CLIENT = 'CET_DEV_NEW';
// export const KEYCLOCK_USERNAME = 'admin';
// export const DOCUMENT_BASE_URL = process.env.REACT_APP_DOCUMENT_BASE_URL;
// export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
// export const KEYCLOAK_REDIRECT_URI = 'https://mhcet-reg-uat.hubblehox.ai/mhcet/home';
// export const KEYCLOAK_REDIRECT_URI = 'http://localhost:3000/mhcet/home';





 // New Dev Server

// export const API_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
// export const FRONTEND_URL  = 'https://mhcet-reg-dev.hubblehox.ai';
// export const BILLDESK_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
// export const KEYCLOCK_REALM = 'CET_DEV_NEW';
// export const KEYCLOCK_CLIENT = 'CET_DEV_NEW';
// export const KEYCLOCK_USERNAME = 'admin';
// export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
// export const KEYCLOAK_REDIRECT_URI = 'https://mhcet-reg-dev.hubblehox.ai/mhcet/home';


// Test SErver

// export const API_URL = 'https://mhcet-test.praathee.in/api';
// export const FRONTEND_URL  = 'https://mhcet-test.praathee.in';
// export const BILLDESK_URL = 'https://mhcet-test.praathee.in/api';
// export const KEYCLOCK_REALM = 'CET_TEST';
// export const KEYCLOCK_CLIENT = 'CET_TEST';
// export const KEYCLOCK_USERNAME = 'admin';
// export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
   





















// export const KEYCLOCK_REALM = 'myrealm';
// export const KEYCLOCK_CLIENT = 'myclient';
// export const KEYCLOCK_URL = 'http://localhost:8080';
// export const KEYCLOCK_USERNAME = 'kuralnithi1999@gmail.com';



// Bill desk test
// export const API_URL = 'http://34.93.35.227:8087';
// export const FRONTEND_URL  = 'http://localhost:3000';
// export const BILLDESK_URL = 'http://34.93.35.227:8086';


// export const API_URL = 'http://18.143.159.223:5000'; //old url
// export const API_URL = 'http://54.169.144.238:3001'; //TEST url

// export const API_URL = "http://34.93.35.227:3001"; //UAT url
// export const FRONTEND_URL = 'http://34.93.35.227:8080';
// export const BILLDESK_URL = 'http://34.93.35.227:3001';

